import React from 'react';
import {
  CheckCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';

interface ConclusionCardProps {
  status: 'good' | 'warning' | 'bad';
  title: string;
  message: string;
  details?: string[];
}

const iconMap = {
  good: <CheckCircleOutlined style={{ color: '#15be53', fontSize: 20 }} />,
  warning: <WarningOutlined style={{ color: '#e6a200', fontSize: 20 }} />,
  bad: <CloseCircleOutlined style={{ color: '#df1b41', fontSize: 20 }} />,
};

const ConclusionCard: React.FC<ConclusionCardProps> = ({ status, title, message, details }) => {
  return (
    <div
      className={`conclusion-${status}`}
      style={{
        padding: '16px 20px',
        borderRadius: '0 8px 8px 0',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
        {iconMap[status]}
        <span style={{ fontSize: 15, fontWeight: 600 }}>{title}</span>
      </div>
      <p style={{ margin: '0 0 8px 0', fontSize: 14, lineHeight: 1.6 }}>{message}</p>
      {details && details.length > 0 && (
        <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, lineHeight: 1.8 }}>
          {details.map((d, i) => (
            <li key={i}>{d}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ConclusionCard;
